export const WORD_LENGTH = 5; 